module.exports = __webpack_public_path__ + "img/0.e47ff672.svg";